function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-25%",
  y: "-25%",
  width: "150%",
  height: "150%",
  filterUnits: "objectBoundingBox",
  id: "icon-arrow_svg__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.384313725 0 0 0 0 0.878431373 0 0 0 0 0.850980392 0 0 0 0.811141304 0",
  "in": "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("circle", {
  id: "icon-arrow_svg__b",
  cx: 6,
  cy: 6,
  r: 6
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#icon-arrow_svg__a)",
  xlinkHref: "#icon-arrow_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#62E0D9",
  xlinkHref: "#icon-arrow_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.582 6l-.363.35 1.452 1.4H5.333v.5h4.338L8.22 9.65l.363.35 2.074-2z",
  fill: "#1B2330"
}));

function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxjaXJjbGUgaWQ9ImIiIGN4PSI2IiBjeT0iNiIgcj0iNiIvPjxmaWx0ZXIgeD0iLTI1JSIgeT0iLTI1JSIgd2lkdGg9IjE1MCUiIGhlaWdodD0iMTUwJSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYSI+PGZlT2Zmc2V0IGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxIiBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiLz48ZmVDb2xvck1hdHJpeCB2YWx1ZXM9IjAgMCAwIDAgMC4zODQzMTM3MjUgMCAwIDAgMCAwLjg3ODQzMTM3MyAwIDAgMCAwIDAuODUwOTgwMzkyIDAgMCAwIDAuODExMTQxMzA0IDAiIGluPSJzaGFkb3dCbHVyT3V0ZXIxIi8+PC9maWx0ZXI+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+PHVzZSBmaWxsPSIjMDAwIiBmaWx0ZXI9InVybCgjYSkiIHhsaW5rOmhyZWY9IiNiIi8+PHVzZSBmaWxsPSIjNjJFMEQ5IiB4bGluazpocmVmPSIjYiIvPjwvZz48cGF0aCBkPSJNOC41ODIgNmwtLjM2My4zNSAxLjQ1MiAxLjRINS4zMzN2LjVoNC4zMzhMOC4yMiA5LjY1bC4zNjMuMzUgMi4wNzQtMnoiIGZpbGw9IiMxQjIzMzAiLz48L2c+PC9zdmc+";
export { SvgIconArrow as ReactComponent };